import {
    View, Text, colors, Button, Heading
} from '@fairygodboss/ui';
import React, { forwardRef, useEffect, useState } from 'react';

import { AuthWrapper } from '../../components/SharedLayout/AuthWrapper/AuthWrapper';
import {
    DividerSVG,
    ConvincerSVG,
    MailBoxSVG,
} from '../../components/SharedLayout/ContentBody/ConvincerSVGs';

export const ConvincerButton = ({
    text,
    useWindowWidth = true,
    onConvincerClick,
    ...others
}) => {
    const [windowWidth, setWindowWidth] = useState();
    useEffect(() => {
        setWindowWidth(window.innerWidth);
    }, []);
    return (
        <Button
            onPress={onConvincerClick}
            mt="8px"
            maxWidth={{ _: '227px', md: '225px' }}
            height="56px"
            px="28px"
            py="14px"
            size="medium"
            fontSize="16px"
            lineHeight="20px"
            alignSelf={{ _: 'auto' }}
            borderRadius={{ _: '56px', md: '4px' }}
            {...(windowWidth < 905
                && useWindowWidth && {
                width: '227px',
            })}
            boxShadow={{ _: '0px 12px 32px rgba(53, 53, 53, 0.4)', md: 'none' }}
            {...others}
        >
            {text}
        </Button>
    );
};

ConvincerButton.displayName = 'ConvincerButton';

export const ConvincerWithBullets = () => {
    const [ready, setReady] = useState(false);
    useEffect(() => {
        setReady(true);
    }, []);
    const bulletPoints = [
        {
            text: `<svg
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none"
                style="margin-right: 8px;"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M4.43359 0L-3.52854e-05 3.13519L2.71686 8.25145L7.15049 5.11626L4.43359 0Z"
                    fill="#D09FD8"
                />
            </svg>
            Daily articles on career topics`,
        },
        {
            text: `<div
                     style="display: flex; flex-direction: row;"
                    >
                    <svg
                    width="8"
                    height="10"
                    viewBox="0 0 8 10"
                    fill="none"
                    style="margin-right: 11px; margin-top: 5px"
                    xmlns="http://www.w3.org/2000/svg"
                >
                <path
                    d="M2.22314 0L-8.46416e-05 6.51302L5.64462 9.079L7.86785 2.56598L2.22314 0Z"
                    fill="#982EA9"
                />
            </svg>

            <div > Jobs at companies dedicated to hiring more women</div>
            </div>`,
        },
        {
            text: `<div
                     style="display: flex; flex-direction: row;"
                    >
<svg
                width="10"
                height="12"
                viewBox="0 0 10 12"
                fill="none"
                style="margin-right: 11px; margin-top: 5px"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9.80542 5.70581L4.94559 1.90483e-05L-0.000119688 5.60727L4.85971 11.3131L9.80542 5.70581Z"
                    fill="#B394F2"
                />
            </svg>
            <div>
            Advice and support from an authentic community
            </div>
            </div>`,
        },
        {
            text: `<div
                     style="display: flex; flex-direction: row;"
                    >
                    <svg
                    width="9"
                    height="11"
                    viewBox="0 0 9 11"
                    fill="none"
                    style="margin-right: 11px; margin-top: 5px"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8.81689 8.13989L6.55892 0.574086L7.32022e-05 3.16776L2.25804 10.7336L8.81689 8.13989Z"
                        fill="#D09FD8"
                    />
                </svg>
            <div>Events that help you level up in your career</div>
            </div>`,
        },
        {
            text: `<div
                     style="display: flex; flex-direction: row;"
                    ><svg width="8" height="9"
                viewBox="0 0 8 9"
                fill="none"
                style="margin-right: 8px;"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.74438 2.33643L2.02561 2.77353e-05L0.000114334 6.59872L5.71889 8.93512L7.74438 2.33643Z"
                    fill="#B394F2"
                />
                </svg>
                <div><strong>Free</strong> membership, always</div></div>`,
        },
    ];

    const BulletPoint = ({ text }) => (
        <View
            as="li"
            lineHeight="20px"
            letterSpacing="-0.4px"
            fontSize="16px"
            backgroundRepeat="no-repeat"
            pt="10px"
            color={colors.neutral[100]}
            dangerouslySetInnerHTML={{ __html: text }}
        />
    );

    return (
        <View pl={{ _: '0px', md: '12px', lg: '0px' }}>
            <DividerSVG width="100" />
            <Heading fontWeight="700" variant="headingXs" pt="8px" as="h3">
                Why women love us:
            </Heading>
            <View as="ul" className="bullet-point" padding="0px" margin="0px">
                <style global jsx>
                    {`
                        .bullet-point {
                            list-style-type: none !important;
                        }
                    `}
                </style>
                {bulletPoints.map((j) => (
                    <BulletPoint
                        key={j.text.split(' ').join('-')}
                        text={j.text}
                        svg={j.svg}
                    />
                ))}
            </View>
            {ready && (
                <AuthWrapper
                    redirectUrl="/community/feed"
                    loginTrigger="article_join_sticky_button"
                    customMetric={{
                        fireMultiple: true,
                    }}
                >
                    <ConvincerButton
                        useWindowWidth={false}
                        text="Join now"
                        width="130px"
                        mt="16px"
                        height="48px"
                    />
                </AuthWrapper>
            )}
        </View>
    );
};

ConvincerWithBullets.displayName = 'ConvincerWithBullets';

const TopConvincer = () => (
    <>
        <View display="flex" justifyContent="center">
            <ConvincerSVG />
        </View>
        <DividerSVG width="100" />
        <Heading
            fontWeight="700"
            variant="headingXs"
            pt="6px"
            pb="10px"
            as="h3"
        >
            Welcome to Fairygodboss!
        </Heading>
        <Text mb="6px">
            We’re the largest online career community helping women achieve
            their career goals. Gain access to articles, jobs, events, and a
            supportive network of women and allies. Membership is free, always.
        </Text>
        <AuthWrapper
            redirectUrl="/community/feed"
            loginTrigger="article_join_banner_button"
            customMetric={{
                fireMultiple: true,
            }}
        >
            <ConvincerButton
                text="Join the community"
                height="48px"
                width="220px"
            />
        </AuthWrapper>
    </>
);

TopConvincer.displayName = 'TopConvincer';

// eslint-disable-next-line no-empty-pattern
export const Convincer = forwardRef(({}, ref) => (
    <View
        ref={ref}
        id="top-convincer"
        display={{ _: 'none', md: 'flex' }}
        flexDirection="column"
        width="100%"
        pl={{ _: '0px', md: '12px', lg: '0px' }}
    >
        <TopConvincer />
    </View>
));

// eslint-disable-next-line no-empty-pattern
export const JobConvincer = forwardRef(({}, ref) => (
    <View
        ref={ref}
        id="job-convincer"
        display={{ _: 'none', md: 'flex' }}
        flexDirection="column"
        width="100%"
        pl={{ _: '0px', md: '12px', lg: '0px' }}
    >
        <View display="flex" justifyContent="center">
            <MailBoxSVG />
        </View>
        <DividerSVG width="100" />
        <Heading
            fontWeight="700"
            variant="headingXs"
            pt="6px"
            pb="10px"
            as="h3"
        >
            Get jobs straight to your inbox
        </Heading>
        <Text mb="6px">
            Anonymous company reviews, virtual recruiting events, and a
            supportive community for women when you sign up.
        </Text>
        <AuthWrapper
            redirectUrl="/community/feed"
            loginTrigger="job_join_banner_button"
            customMetric={{
                fireMultiple: true,
            }}
        >
            <ConvincerButton
                text="Sign up for free"
                height="48px"
                width="220px"
            />
        </AuthWrapper>
    </View>
));
